import Vue from 'vue'
import App from './AppForm.vue'
// import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import api from './api'
import Rules from './plugins/rules'
import Confirm from './plugins/confirm'
import VueMoment from 'vue-moment'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import i18n from './i18n'
// import FlagIcon from 'vue-flag-icon'

Vue.config.productionTip = false

axios.defaults.withCredentials = true
Vue.use(VueAxios, axios)

Vue.use(VueLodash, { name: 'custom', lodash: lodash })

const el = document.getElementById('payment-form')
if (el && el.dataset && el.dataset.locale) {
  store.state.locale = el.dataset.locale
}

momentDurationFormatSetup(moment)
moment.locale(store.state.locale)
Vue.use(VueMoment, { moment })
Vue.filter('duration', function (duration) {
  return moment.duration(duration, 'seconds').format('hh:mm:ss', { trim: false })
})

// Vue.use(FlagIcon)

Object.defineProperties(Vue.prototype, {
  $api: {
    get () {
      return api
    }
  }
})

Vue.use(Rules)
Vue.use(Confirm, { vuetify, title: 'Warning' })

const moneyFormatter = new Intl.NumberFormat(store.state.locale, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

const moneyDoubleFormatter = new Intl.NumberFormat(store.state.locale, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4
})

const trafficFormatter = new Intl.NumberFormat(store.state.locale, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

Vue.filter('money', function (val) {
  return isNaN(val) ? val : moneyFormatter.format(val)
})

Vue.filter('moneyDouble', function (val) {
  return isNaN(val) ? val : moneyDoubleFormatter.format(val)
})

Vue.filter('bytes', function (bytes, decimals, kib, maxunit) {
  kib = kib || false
  if (bytes === 0) return '0 B'
  if (isNaN(parseFloat(bytes)) && !isFinite(bytes)) return 'Not an number'
  const k = kib ? 1024 : 1000
  const dm = decimals != null && !isNaN(decimals) && decimals >= 0 ? decimals : 2
  const sizes = kib ? ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB', 'BiB'] : ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB', 'BB']
  var i = Math.floor(Math.log(bytes) / Math.log(k))
  if (maxunit !== undefined) {
    const index = sizes.indexOf(maxunit)
    if (index !== -1) i = index
  }
  return trafficFormatter.format(parseFloat((bytes / Math.pow(k, i)).toFixed(dm))) + ' ' + sizes[i]
})

i18n.locale = store.state.locale

Vue.directive('inserted-event', {
  bind: function () {},
  inserted: function (el, binding, vnode) {
    (binding.value)()
  },
  update: function () {},
  componentUpdated: function () {},
  unbind: function () {}
})

new Vue({
  // router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#payment-form')
